import {z} from 'zod';

export const UtmParametersSchema = z.object({
  source: z.string().nullable(),
  medium: z.string().nullable(),
  campaign: z.string().nullable(),
  content: z.string().nullable(),
  term: z.string().nullable(),
});
export type UtmParameters = z.infer<typeof UtmParametersSchema>;

export const EMPTY_UTM_PARAMETERS: UtmParameters = {
  source: null,
  medium: null,
  campaign: null,
  content: null,
  term: null,
};
